module.exports = __webpack_public_path__ + "static/media/RougeScript-Regular.76643521.ttf";